import { format } from "date-fns";
import { useState } from "react";
import ReactHTMLTableToExcel from "react-html-table-to-excel";

const Filtro = ({
  params,
  judicial,
  setJudicial,
  setParams,
  loading
}) => {
  //Initial States
  const [param, setParam] = useState(params)
  const estados = ["TOTAL", "PARCIAL", "EXCEDENTE", "BAJA"];

  const onClick = (e, value) => {
    switch (e.target.name) {
      case "estado": {
        let result = param.estado;
        let state = false;
        let key = 0;


        result.map((campos, index) => {
          if(value == campos){
            state = true;
            key = index;
          } 
        })


        if(state){
          delete(result[key]);
          result = result.filter((item) => {
            return item != null;
          });
        } else {
          result.push(value)
        }

        setParam({
          ...param,
          estado: result
        })
      } break;
    }
  }

  const onChange = (e) => {
    switch (e.target.name) {
      case "gasto-judicial":
        {
          setJudicial(e.target.checked ? true : false);
          //setParams({
          //  ...params,
          //  [e.target.name]: e.target.checked ? 1 : 0
          //})
        }
        break;
      case "search":
        {
          setParam({
            ...param,
            search: e.target.value,
          });
        }
        break;
      case "nro_documento":
        {
          setParam({
            ...param,
            nro_documento: e.target.value,
          });
        }
        break;
      case "start_date":
        {
          setParam({
            ...param,
            start_date: e.target.value,
          });
        }
        break;
      case "end_date":
        {
          setParam({
            ...param,
            end_date: e.target.value,
          });
        }
        break;
    }
  };

  console.log(params);
  return (
    <div style={{
      background: 'linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 100%)',
      borderRadius: '16px',
      padding: '24px',
      marginBottom: '24px',
      border: '1px solid #E2E8F0'
    }}>
      <div className="row g-3">
        <div className="col-md-2 col-12">
          <div className="mb-3">
            <label className="form-label fw-bold" style={{ fontSize: '0.875rem', color: '#475569' }}>
              FECHA DE INICIO
            </label>
            <input
              type="date"
              className="form-control"
              style={{
                borderRadius: '10px',
                border: '1px solid #CBD5E1',
                padding: '10px 14px',
                fontSize: '0.95rem'
              }}
              defaultValue={params.start_date}
              name="start_date"
              onChange={(event) => onChange(event)}
              disabled={loading}
            />
          </div>
        </div>
        <div className="col-md-2 col-12">
          <div className="mb-3">
            <label className="form-label fw-bold" style={{ fontSize: '0.875rem', color: '#475569' }}>
              FECHA DE FIN
            </label>
            <input
              type="date"
              className="form-control"
              style={{
                borderRadius: '10px',
                border: '1px solid #CBD5E1',
                padding: '10px 14px',
                fontSize: '0.95rem'
              }}
              defaultValue={params.end_date}
              name="end_date"
              onChange={(event) => onChange(event)}
              disabled={loading}
            />
          </div>
        </div>

        <div className="col-md-2 col-12">
          <div className="mb-3">
            <label className="form-label fw-bold" style={{ fontSize: '0.875rem', color: '#475569' }}>
              DNI PERSONA
            </label>
            <input
              type="text"
              className="form-control"
              style={{
                borderRadius: '10px',
                border: '1px solid #CBD5E1',
                padding: '10px 14px',
                fontSize: '0.95rem'
              }}
              name="nro_documento"
              onChange={(event) => onChange(event)}
              disabled={loading}
            />
          </div>
        </div>

        <div className="col-md-3 col-12">
          <div className="mb-3">
            <label className="form-label fw-bold" style={{ fontSize: '0.875rem', color: '#475569' }}>
              ESTADOS
            </label>
            <div className="btn-group" role="group" style={{ width: '100%' }}>
              <button
                type="button"
                className={
                  param.estado.indexOf("TOTAL") > -1
                    ? "btn btn-sm"
                    : "btn btn-sm"
                }
                style={{
                  background: param.estado.indexOf("TOTAL") > -1
                    ? 'linear-gradient(135deg, #059669 0%, #047857 100%)'
                    : '#FFFFFF',
                  color: param.estado.indexOf("TOTAL") > -1 ? '#FFFFFF' : '#64748B',
                  border: '1px solid #CBD5E1',
                  borderRadius: '8px 0 0 8px',
                  fontSize: '0.85rem',
                  padding: '8px 12px',
                  fontWeight: '600'
                }}
                name="estado"
                onClick={(e) => onClick(e, "TOTAL")}
              >
                TOTAL
              </button>
              <button
                type="button"
                className="btn btn-sm"
                style={{
                  background: param.estado.indexOf("PARCIAL") > -1
                    ? 'linear-gradient(135deg, #F59E0B 0%, #D97706 100%)'
                    : '#FFFFFF',
                  color: param.estado.indexOf("PARCIAL") > -1 ? '#FFFFFF' : '#64748B',
                  border: '1px solid #CBD5E1',
                  fontSize: '0.85rem',
                  padding: '8px 12px',
                  fontWeight: '600'
                }}
                name="estado"
                onClick={(e) => onClick(e, "PARCIAL")}
              >
                PARCIAL
              </button>
              <button
                type="button"
                className="btn btn-sm"
                style={{
                  background: param.estado.indexOf("EXCEDENTE") > -1
                    ? 'linear-gradient(135deg, #0EA5E9 0%, #0284C7 100%)'
                    : '#FFFFFF',
                  color: param.estado.indexOf("EXCEDENTE") > -1 ? '#FFFFFF' : '#64748B',
                  border: '1px solid #CBD5E1',
                  fontSize: '0.85rem',
                  padding: '8px 12px',
                  fontWeight: '600'
                }}
                name="estado"
                onClick={(e) => onClick(e, "EXCEDENTE")}
              >
                EXCEDENTE
              </button>
              <button
                type="button"
                className="btn btn-sm"
                style={{
                  background: param.estado.indexOf("BAJA") > -1
                    ? 'linear-gradient(135deg, #64748B 0%, #475569 100%)'
                    : '#FFFFFF',
                  color: param.estado.indexOf("BAJA") > -1 ? '#FFFFFF' : '#64748B',
                  border: '1px solid #CBD5E1',
                  borderRadius: '0 8px 8px 0',
                  fontSize: '0.85rem',
                  padding: '8px 12px',
                  fontWeight: '600'
                }}
                name="estado"
                onClick={(e) => onClick(e, "BAJA")}
              >
                BAJA
              </button>
            </div>
          </div>
        </div>

        <div className="col-md-3 col-12">
          <label className="form-label fw-bold" style={{ fontSize: '0.875rem', color: '#475569' }}>
            GASTO JUDICIAL
          </label>
          <div className="form-check form-switch" style={{ paddingTop: '8px' }}>
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id="flexSwitchCheckDefault"
              name="gasto-judicial"
              onChange={(e) => onChange(e)}
              checked={judicial}
              disabled={loading}
              style={{
                width: '48px',
                height: '24px',
                cursor: 'pointer'
              }}
            />
            <label className="form-check-label" htmlFor="flexSwitchCheckDefault" style={{ marginLeft: '8px', color: '#64748B' }}>
              Filtrar por gastos judiciales
            </label>
          </div>
        </div>

        <div className="col-md-12">
          <div className="mb-3">
            <label className="form-label fw-bold" style={{ fontSize: '0.875rem', color: '#475569' }}>
              BUSCAR CLIENTE
            </label>
            <div className="d-flex align-items-center" style={{ position: 'relative' }}>
              <i className="bi bi-search" style={{
                position: 'absolute',
                left: '14px',
                color: '#94A3B8',
                fontSize: '1.1rem'
              }}></i>
              <input
                type="text"
                className="form-control"
                style={{
                  borderRadius: '10px',
                  border: '1px solid #CBD5E1',
                  paddingLeft: '44px',
                  padding: '10px 14px 10px 44px',
                  fontSize: '0.95rem',
                  maxWidth: '500px'
                }}
                placeholder="Buscar por nombre del cliente..."
                autoComplete="off"
                name="search"
                onChange={(event) => onChange(event)}
                disabled={loading}
              />
            </div>
          </div>
        </div>

        <div className="col-md-12">
          <div className="d-flex gap-3 align-items-center">
            <button
              className="btn"
              style={{
                background: 'linear-gradient(135deg, #0EA5E9 0%, #0284C7 100%)',
                color: '#FFFFFF',
                border: 'none',
                borderRadius: '10px',
                padding: '10px 24px',
                fontSize: '0.95rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
              onClick={(e) => setParams({...param})}
              onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
              onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              <i className="bi bi-funnel me-2"></i>FILTRAR
            </button>

            <label
              className="btn"
              style={{
                background: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
                color: '#FFFFFF',
                border: 'none',
                borderRadius: '10px',
                padding: '10px 24px',
                fontSize: '0.95rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                margin: 0
              }}
              title="Descargar reporte formato Excel"
              onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
              onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              <i className="bi bi-file-earmark-excel me-2"></i>Exportar a Excel
              <ReactHTMLTableToExcel
                id="buttonDownloadExcel"
                className="d-none"
                table="tabla_caja"
                filename={
                  "cierre-caja-" + format(new Date(), "d-M-yyyy").toString()
                }
                sheet="pagina 1"
                buttonText="Exportar tabla"
              />
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Filtro;
